import {request} from './request'

//添加地址
export function addAddress(params){
    return request({
        url:'/api/address',
        method:'post',
        params
    })
}

//编辑地址
export function EditAddress(id,params){
    return request({
        url:`/api/address/${id}`,
        method:'put',
        params
    })
}

//删除地址
export function DeleteAddress(id){
    return request({
        url:`/api/address/${id}`,
        method:'DELETE'
    })
}

//获取地址列表
export function getAddressList(id){
    return request({
        url:'/api/address',
        method:'get'
    })
}

//地址详情
export function getAddressDetail(id){
    return request({
        url:`/api/address/${id}`,
        method:'get'
    })
}
